var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"root"},[_c('div',{staticClass:"date"},[_vm._v("\n\t\t"+_vm._s(_vm.date)+"\n\t")]),_vm._l((_vm.clock),function(digit){return _c('ClockDigit',{attrs:{"digit":digit}})})],2)}
var staticRenderFns = []

export { render, staticRenderFns }